<template>
  <component
    :is="el"
    class="own-card"
    :class="[
      `own-card--${backgroundColor}`,
      `own-card--border-${borderColor}`,
      control && 'own-card--control',
      !hideBorder && `own-card--bordered`,
      borderColor && `border-${borderColor}`,
      dashedBorder && `own-card--dashed-border`,
    ]"
    :style="{ borderRadius: radius }"
  >
    <!--
      @slot default - holds default content
     -->
    <slot />
  </component>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    backgroundColor?:
      | 'primary'
      | 'secondary'
      | 'selected'
      | 'transparent'
      | 'info'
    borderColor?: 'divider' | 'danger' | 'transparent'
    control?: boolean
    dashedBorder?: boolean
    el?: string
    hideBorder?: boolean
    radius?: string
  }>(),
  {
    backgroundColor: 'primary',
    borderColor: 'transparent',
    control: false,
    dashedBorder: false,
    el: 'div',
    hideBorder: false,
    radius: 'var(--radius-regular)',
  }
)
</script>

<style lang="scss">
.own-card {
  display: flex;
  flex-direction: column;

  &.flex-row {
    flex-direction: row;
  }

  &--bordered {
    border: 1px solid transparent;
  }

  &--control {
    box-shadow: var(--shadow-card-default);
  }

  &--dashed-border {
    border-style: dashed;
  }

  &--primary {
    background-color: var(--background-primary);
  }
  &--secondary {
    background-color: var(--background-secondary);
  }
  &--selected {
    background-color: var(--background-active);
  }
  &--info {
    background-color: var(--color-surface-info);
  }
  &--transparent {
    background-color: transparent;
  }

  &--border-divider {
    border-color: var(--divider);
  }
  &--border-danger {
    border-color: var(--status-danger);
  }
  &--border-transparent {
    border-color: transparent;
  }
}
</style>
